import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { StoreFinderComponent } from '../../../store/store-finder.component';
export interface IPageStoreFinderData extends NICmsContentComponent.IData {}
@Component({
    selector: 'page-component-store-finder',
    template: `<store-finder noGeolocationOnInit="true"></store-finder>`,
    standalone: true,
    imports: [StoreFinderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageStoreFinderComponent>({
    id: 'store-finder',
    name: 'Store finder',
    tags: ['stores', 'feature'],
    fields: []
})
export class PageStoreFinderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component: IPageStoreFinderData;
}
